<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OrderList' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'MemberCoupon' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("優惠專區") }}
            </router-link>
          </li>
          <li v-if="local != 'jp' && hasInvite">
            <router-link :to="{ name: 'InvitEvent' }" tag="button" class="active">
              <img src="img/member_icon_friends.svg" alt="" />
              {{ $t("邀請朋友") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main" v-if="InvitEventData">
          <!-- 新增內容 ↓ -->
          <!-- 標題 -->
          <div class="bg-box">
            <h1>邀請朋友</h1>
          </div>
          <!-- 內容文字 -->
          <div class="bg-box">
            <div class="text_title">
              <p>{{ InvitEventData.InvitEvent.InvitTitle }}</p>
            </div>
            <div class="number_box one">
              <div>
                <div class="text">
                  <p>(本月) 已成功加入人數</p>
                  <p>=</p>
                  <p class="number">{{ InvitEventData.InvitCount }}</p>
                </div>
                <p class="line">|</p>
                <div class="text">
                  <p>(本月) 已完成購買人數</p>
                  <p>=</p>
                  <p class="number">{{ InvitEventData.ValidCount }}</p>
                </div>
              </div>
            </div>
            <div class="img_box">
              <img src="img/friends2_img.svg" alt="">
            </div>
            <div class="text_box">
              <div v-html="InvitEventData.InvitEvent.InvitContent"></div>
              <br>
              <p>我的邀請碼：<span class="invitation">{{ InvitEventData.InvitCode }}</span></p>
            </div>
            <div class="btn_box">
              <button class="btn_friends" v-clipboard:copy="InvitEventData.InvitMessage" v-clipboard:success="onCopy"
                v-clipboard:error="onError">複製並分享訊息</button>
            </div>
            <div class="number_box">
              <p class="text_title">歷屆活動累積次數</p>
              <div>
                <div class="text">
                  <p>成功加入人數</p>
                  <p>=</p>
                  <p class="number">{{ InvitEventData.InvitAllCount }}</p>
                </div>
                <p class="line">|</p>
                <div class="text">
                  <p>完成購買人數</p>
                  <p>=</p>
                  <p class="number">{{ InvitEventData.ValidAllCount }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- <hr v-if="InvitEventData.CanAccept">
          <div class="bg-box" v-if="InvitEventData.CanAccept">
            <div class="text_title">
              <p>好友邀請碼</p>
            </div>
            <div class="invitation_code">
              <p>請輸入收到的邀請碼</p>
              <input class="form-control" type="text" maxlength="12" placeholder="請輸入邀請碼" style="text-align: center;"
                v-model="InvitCode">
              <div class="btn_box">
                <button class="btn_friends" @click="sendAccept()">送出</button>
              </div>
            </div>
          </div> -->
          <hr v-if="InvitEventData.InvitEvent.HowToDoShow">
          <div class="bg-box" v-if="InvitEventData.InvitEvent.HowToDoShow">
            <div class="text_Steps">
              <div class="text_title">
                <p>{{ InvitEventData.InvitEvent.HowToDoTitle }}</p>
              </div>
              <div v-html="InvitEventData.InvitEvent.HowToDoContent">
              </div>
            </div>
          </div>
          <!-- 新增內容 ↑ -->
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Paginate from "vuejs-paginate";
import Storage from "@/utils/storage.js";
import { tempdir } from "shelljs";
import VueClipboard from "vue-clipboard2";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);
Vue.component("paginate", Paginate);
Vue.use(VueClipboard);

// this.$t("立即購買")
const messages = {
  zh_tw: {
  },
  en: {
  },
  jp: {
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "InvitEvent",
  i18n,
  data() {
    return {
      InvitEventData: null,
      local: "zh_tw",
      IsTester: false,
      hasInvite: false,
      InvitCode: "",
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
    };
  },
  created: function () {
    let that = this;
    $.ajax({
      url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/InvitEvent",
      //url: "https://localhost:44321/Html/OrderInfo",
      type: "post",
      data: {
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("取得活動資訊過程發生錯誤, 請稍後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      },
      success: function (res) {
        // 判斷結果
        if (res.ok) {
          that.InvitEventData = JSON.parse(res.data);
          that.IsTester = that.InvitEventData.IsTester;
          that.hasInvite = that.InvitEventData.hasInvite;
        } else if (res.error_msg) {
          var error_msg = JSON.parse(res.error_msg);
          if (res.toekn_error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              willClose: function () {
                // 移除登入資訊
                Storage.remove("ek_login_token");
                // 回到首頁
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        }
      },
    });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member_friends");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  updated: function () { },
  methods: {
    timeString(time, format) {
      return moment(time).format(format || "YYYY-MM-DD, HH:mm:ss");
    },
    onCopy(e) {
      // 檢查是否為手機且支援 Web Share API 且在安全上下文中
      this.showCopySuccess();
      if (this.isMobile && navigator.share && window.isSecureContext) {
        try {
          // 手機端且支援 Web Share API，顯示系統分享UI
          navigator.share({
            title: '邀請朋友',
            text: this.InvitEventData.InvitMessage
          }).then(() => {
            console.log('系統分享成功');
          }).catch((error) => {
            console.log('系統分享取消或失敗:', error);
          });
        } catch (error) {
          console.error('Web Share API 執行錯誤:', error);
        }
      }
    },
    showCopySuccess() {
      this.$swal({
        heightAuto: false,
        title: this.$t("複製成功"),
        text: this.InvitEventData.InvitMessage,
        icon: "success",
        allowOutsideClick: false,
        confirmButtonText: this.$t("確定"),
      });
    },
    onError(e) {
      alert(this.$t("複製失敗, 請稍後再試一次"));
    },
    shareToLine() {
      if (this.InvitEventData && this.InvitEventData.InvitMessage) {
        // 對訊息進行 URL 編碼
        const encodedMessage = encodeURIComponent(this.InvitEventData.InvitMessage);
        // 建立 LINE 分享 URL
        const lineShareUrl = `https://line.me/R/share?text=${encodedMessage}`;
        if (this.isMobile && typeof cordova != "undefined") {
          cordova.InAppBrowser.open(
            lineShareUrl,
            "_blank",
            "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
            this.$t("關閉") +
            ",closebuttoncolor=#ffffff"
          );
        } else {
          window.open(lineShareUrl, "_blank");
        }
      } else {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("分享訊息不存在"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
      }
    },
    sendAccept() {
      let that = this;
      if (!that.InvitCode || that.InvitCode.length != 12) {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("請輸入正確的邀請碼"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      } else {
        // 顯示請稍候
        that.$swal({
          heightAuto: false,
          title: that.$t("請稍候..."),
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: function () {
            that.$swal.showLoading();
          },
        });
        $.ajax({
          url:
            that.GLOBAL.apiSrc +
            that.GLOBAL.subDirectory +
            "/Htmlv2/AcceptInvit",
          type: "post",
          data: {
            InvitCode: that.InvitCode,
            token: Storage.get("ek_login_token"),
          },
          dataType: "json",
          async: false,
          error: function () {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: that.$t("處理過程發生錯誤, 請稍後再試一次"),
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          },
          success: function (res) {
            // 判斷結果
            if (res.ok) {
              that.$swal({
                heightAuto: false,
                title: that.$t("完成"),
                icon: "success",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
                willClose: function () {
                  location.reload();
                },
              });
            } else if (res.error_msg) {
              var error_msg = JSON.parse(res.error_msg);
              if (res.toekn_error) {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  willClose: function () {
                    // 移除登入資訊
                    Storage.remove("ek_login_token");
                    // 回到首頁
                    that.$router.push({
                      name: "Home",
                      params: {},
                    });
                  },
                });
              } else {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            }
          },
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.member_friends .invitation {
  font-size: 1.1rem;
  font-weight: 600;
  color: #206698;
}

.member_friends .invitation_code {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}

.member_friends .invitation_code .form-control {
  padding: 6px 15px;
  padding-bottom: 4px;
  font-size: 1rem;
  margin-top: 10px;
  width: 80%;
}

.member_friends .invitation_code .form-control::placeholder {
  font-weight: 300;
  color: #989898;
}

.member_friends .bg-box .invitation_code .btn_box {
  margin: 10px 0;
}

.member_friends .bg-box .invitation_code .btn_friends {
  animation: none;
  width: 120px;
}

.member_friends .number_box {
  flex-direction: column;
  margin: 15px 0px;
}


.member_friends .number_box div {
  margin: 5px 0;
}

.number_box.one div {
  border: 1px solid #206698;
  color: #fc6b53;
}

.member_friends .number_box .text {
  margin: 0;
  border: none;
}

.member_friends .number_box p {
  padding: 0 5px;
  color: #206698;
  font-weight: 400;
}

.number_box.one p {
  font-weight: 600;
}

.member_friends .number_box p.number {
  font-size: 1.4rem;
  color: #206698;
}

.member_friends .number_box.one p.number {
  color: #FC6B53;
  font-size: 1.6rem;
}

.member_friends .number_box p.line {
  margin: 0;
}

.member_friends .number_box p.text_title {
  width: 100%;
  font-size: 1.05rem;
  margin-bottom: 2px;
  padding-bottom: 0px;
  border: none;
  font-weight: 400;
  border-top: 1px dashed #E0E7EE;
  padding-top: 12px;
}

.member_friends .number_box::before {
  content: none;
}


@media (max-width: 575.98px) {

  .member_friends .number_box p.line {
    display: none;
  }

  .member_friends .number_box div {
    flex-direction: column;
    width: 100%;
    max-width: 300px;
  }

  .member_friends .number_box .text {
    flex-direction: row;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InvitEvent.vue